(function () {
  const DEFAULT_LABEL_MODAL_MESSAGE = 'Always read the label before adding new products to your pack. Always follow the directions for use.';

  function formatMessageToHtml(message) {
    if (!message || typeof message !== 'string') {
      return '<p>' + DEFAULT_LABEL_MODAL_MESSAGE + '</p>';
    }

    const escaped = message
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;');

    const paragraphs = escaped
      .split(/\n{2,}|\r\n{2,}/)
      .map(function (part) { return part.trim(); })
      .filter(Boolean);

    if (!paragraphs.length) {
      return '<p>' + DEFAULT_LABEL_MODAL_MESSAGE + '</p>';
    }

    return paragraphs.map(function (paragraph) {
      return '<p>' + paragraph + '</p>';
    }).join('');
  }

  function injectModal() {
    if (!document.getElementById('personalised-label-modal')) {
      const modalHTML = `
        <div id="personalised-label-modal" class="reco-modal personalised-label-modal reco-hidden" role="dialog" aria-modal="true" aria-label="Product information">
          <div class="reco-modal-content">
            <div class="reco-modal-message">
              <p>${DEFAULT_LABEL_MODAL_MESSAGE}</p>
            </div>
            <div class="reco-modal-actions">
              <button id="label-modal-continue" class="reco-btn">Continue</button>
            </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectModal);
  } else {
    injectModal();
  }

  window.personalised = window.personalised || {};
  window.personalised.labelModal = {
    showLabelModal: function (message) {
      return new Promise((resolve) => {
        const modal = document.getElementById('personalised-label-modal');
        if (!modal) {
          return resolve(true);
        }

        const messageEl = modal.querySelector('.reco-modal-message');
        if (messageEl) {
          messageEl.innerHTML = formatMessageToHtml(message);
        }

        modal.classList.remove('reco-hidden');

        const continueBtn = modal.querySelector('#label-modal-continue');
        const handleContinue = () => {
          modal.classList.add('reco-hidden');
          continueBtn.removeEventListener('click', handleContinue);
          resolve(true);
        };
        
        continueBtn.addEventListener('click', handleContinue);
      });
    }
  };
})();